import { Color } from './color';
import { getTransparent } from '../utils/themer';

export const styles = {
	global: {
		html: {
			// fontSize: '12px',
			bg: 'background',
		},
		body: {
			fontFamily: 'Sora',
			bg: 'background',
			color: 'text',
		},
		p: {
			fontFamily: 'Sora',
		},
		_focus: {
			boxShadow: 'none !important',
			outline: 'none !important',
		},
		_focusVisible: {
			boxShadow: 'none !important',
			outline: 'auto !important',
		},
		td: {
			borderBottom: 'none !important',
		},
		tr: {
			borderBottom: 'none !important',
			position: 'relative',
			_after: {
				content: '""',
				width: 'calc(100% - 16px)',
				height: '1px',
				background: getTransparent(Color.TEXT, 10),
				position: 'absolute',
				top: '0',
				left: '8px',
			},
			_first: {
				_after: {
					content: 'unset',
				},
			},
		},
	},
};
